import { FC, useContext } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../CustomBody/index";
import { SwitchButton, Tooltips } from "../../../atomic";
import { CustomButton } from "../../../Forms"

//Assets
import Scooter from "../../../../images/scooter.png";
import FileProtection from "../../../../images/file-protection.png";
import Delivery from "../../../../images/delivery.png";

// Helpers
import { formatCurrency } from "../../../../utils/Helpers";

//Context
import ShipperContext from "../context";

//Interfaces
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  check,
  loading,
  oneEta,
  logistic,
  rate,
  max_day,
  min_day,
  final_price,
  insurance_fee,
  base_price,
  toastMessage,
  must_use_insurance,
  resetToastMessage,
  onBack,
  setCheckHander,
  confirmHandler,
}) => {
  const { ratio, currency } = useContext(ShipperContext);

  // Components
  const RenderDay = (day) => day > 1 ? "days" : "day";
  const RenderEtaText = () => {
    if (oneEta) return <p className="eta">ETA delivery: {min_day} {RenderDay(min_day)}</p>;

    return <p className="eta">ETA delivery: {min_day} {RenderDay(min_day)} - {max_day} {RenderDay(max_day)}</p>
  }

  return (
    <CustomBody resetToast={resetToastMessage} toastMessage={toastMessage} loading={loading} withBack backAction={onBack}>
      <div className="confirm-logistic-body">
        <p className="header">Logistic Confirmation</p>

        {/*Selected Logistic */}
        <div className="logistic-card">
          <KickImage className="left-img" src={Scooter} alt="card" />
          <div className="text-wrapper">
            <p className="title">{logistic?.name} - {rate?.type}</p>
            {RenderEtaText()}
          </div>
          <KickImage className="logistic-icon" src={logistic?.logo_url} alt="..." />
        </div>

        {/*Insurance */}
        {insurance_fee ? <div className="insurance-card">
          <div className="insurance-inside-card">
            <KickImage className="fileprotection-icon" src={FileProtection} alt="card" />
            <div className="text-wrapper">
              <p className="title">Add extra safety <Tooltips placement={"bottom"} /></p>
              <p className="price">{formatCurrency(insurance_fee, ratio, currency)}</p>
            </div>
            <SwitchButton check={check} setCheck={setCheckHander} />
          </div>
          {must_use_insurance ? <p className="must-insurance-info">This service is auto-applied, you cannot cancel this service</p> : null}
        </div> : null}

        {/*Total payment */}
        <div className="total-payment-card">
          <div className="payment-info">
            <KickImage className="delivery-icon" src={Delivery} alt="delivery" />
            <div className="text-wrapper">
              <p className="title">Total payment</p>
              <p className="info">Total payment will be automatically taken from the revenue after the sales completed.</p>
            </div>
          </div>

          <div className="fee-wrapper">
            <p className="label">Shipping fee</p>
            <p className="price">{formatCurrency(base_price, ratio, currency)}</p>
          </div>
          {check ?
            <div className="fee-wrapper">
              <p className="label">Insurance</p>
              <p className="price">{formatCurrency(insurance_fee, ratio, currency)}</p>
            </div>
            : null}
          <div className="fee-wrapper total">
            <p className="label">Total</p>
            <p className="price">{formatCurrency(final_price, ratio, currency)}</p>
          </div>
        </div>

        {/* Button */}
        <CustomButton text="Confirm" disabled={false} onClick={() => confirmHandler()} />
      </div>
    </CustomBody>
  )
}
export default Component;